export default __webpack_public_path__ + "static/media/file-icon.6e55541e.svg";